<script setup lang="ts">
export interface PopOutProps {
  class?: string
  backdropClass?: string
  mobileFull?: boolean
}

const props = defineProps<PopOutProps>()

const emits = defineEmits(['close'])
</script>

<template>
  <div
    class="z-popout right-0 overflow-y-auto p-5 text-left text-xs text-black lg:shadow-lg"
    :class="{
      [String(props.class)]: !!props.class,
      'shadow-medium-inner fixed bottom-0 left-0 lg:absolute lg:bottom-auto lg:left-auto lg:top-full lg:h-auto':
        props.mobileFull,
      absolute: !props.mobileFull,
    }"
  >
    <slot />
  </div>

  <div
    class="z-popout-backdrop absolute -left-[100vw] top-full h-screen w-[200vw] cursor-pointer bg-black bg-opacity-40"
    :class="[
      props.backdropClass,
      {
        'hidden lg:block': props.mobileFull,
      },
    ]"
    @click="emits('close')"
  />
</template>
